module.exports = __webpack_public_path__ + "img/title-3.1bfa74b0.png";